export default "__VITE_ASSET__BPcEYh5Q__"